import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppMaterialModule } from '../../app.material.module';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {PropertyViewRoutingModule} from "./property-view-routing.module";
import {PropertyViewComponent} from "./property-view.component";
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { LockDialogComponent } from '../dialogs/property-access-rights-dialog/lock-dialog.component';
import { BusinessRuleDialogComponent } from '../dialogs/property-business-rule/business-rule.component';
import { DataTypeComponent } from '../data-type/data-type.component';
import { EditDataTypeComponent } from '../dialogs/edit-data-type/edit-data-type.component';
import { DataTypeAccessRightsComponent } from '../dialogs/data-type-access-rights/data-type-access-rights.component';

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        PropertyViewRoutingModule,
        AppMaterialModule,
        FormsModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        

    ],

    declarations: [
        PropertyViewComponent,
        LockDialogComponent,
        BusinessRuleDialogComponent, 
        DataTypeComponent,
        EditDataTypeComponent,
        DataTypeAccessRightsComponent

    ],
})

export class PropertyViewModule { }
